import React from 'react'
import { Link } from 'react-router-dom'

function UserAgreementPage() {
  return (
    <div className="app">
      <div id="stars"></div>
      <div className="wrapper privacy-wrapper">
        <header className="privacy-header">
          <h1>用户协议</h1>
          <p className="privacy-subtitle">User Agreement</p>
        </header>

        <main className="privacy-content">
          <section className="privacy-section">
            <p className="agreement-date">更新日期：2026年7月18日</p>
            <p className="agreement-date">生效日期：2026年7月18日</p>
          </section>

          <section className="privacy-section">
            <h2>一、协议的接受</h2>
            <p>
              欢迎使用萝卜水印相机。请你仔细阅读本用户协议（以下简称"本协议"）。你下载、安装、注册、登录或以任何方式使用本应用，即表示你已阅读、理解并同意接受本协议全部条款。如果你不同意本协议，请立即停止使用本应用。
            </p>
          </section>

          <section className="privacy-section">
            <h2>二、服务说明</h2>
            <p>
              本应用提供拍照、照片水印添加、AI 文案、位置与天气信息显示等功能。本应用作为工具软件，不存储用户照片到任何服务器。部分功能（如天气信息）需要连接网络，由第三方服务提供。
            </p>
          </section>

          <section className="privacy-section">
            <h2>三、账号与使用规范</h2>
            <ol>
              <li>你应保证使用本应用的行为符合相关法律法规，不得利用本应用从事违法违规活动。</li>
              <li>你不得对本应用进行反向工程、反编译、破解或试图获取源代码。</li>
              <li>你不得干扰或破坏本应用的正常运行，或干扰其他用户的使用。</li>
            </ol>
          </section>

          <section className="privacy-section">
            <h2>四、用户内容</h2>
            <ol>
              <li>用户通过本应用拍摄、编辑、保存的照片和作品内容，其知识产权归用户所有。</li>
              <li>用户应确保其使用本应用生成的内容不侵犯任何第三方的合法权益，否则由用户自行承担全部责任。</li>
              <li>本应用不会收集、上传或分享用户生成的内容。</li>
            </ol>
          </section>

          <section className="privacy-section">
            <h2>五、知识产权</h2>
            <ol>
              <li>本应用的界面设计、代码、图标、商标及相关内容均受著作权法、商标法等法律保护。</li>
              <li>未经开发者书面许可，任何人不得复制、修改、传播、出租、出借或出售本应用及其相关内容。</li>
            </ol>
          </section>

          <section className="privacy-section">
            <h2>六、免责声明</h2>
            <ol>
              <li>本应用提供的位置、天气、方向、时间等水印信息仅供参考，不保证完全准确。</li>
              <li>对于因网络、设备、第三方服务等原因导致的服务中断或数据丢失，开发者不承担责任。</li>
              <li>对于因用户使用本应用而产生的任何直接或间接损失，开发者不承担责任，除非该损失由开发者故意或重大过失造成。</li>
            </ol>
          </section>

          <section className="privacy-section">
            <h2>七、协议修改</h2>
            <p>
              开发者有权根据需要修改本协议。修改后的协议将在应用内公示，并在更新后生效。如果你继续使用本应用，即视为同意修改后的协议。
            </p>
          </section>

          <section className="privacy-section">
            <h2>八、协议终止</h2>
            <p>
              如果你违反本协议，开发者有权暂停或终止向你提供服务。你可以随时停止使用本应用并删除本应用。
            </p>
          </section>

          <section className="privacy-section">
            <h2>九、联系我们</h2>
            <p>如果你对本协议有任何疑问，请通过以下方式与我们联系：</p>
            <ul>
              <li>
                <strong>邮箱：</strong>
                <a href="mailto:luobo2028@163.com">luobo2028@163.com</a>
              </li>
              <li>
                <strong>用户协议链接：</strong>
                <a href="https://openwu.cn/user-agreement" target="_blank" rel="noreferrer">
                  https://openwu.cn/user-agreement
                </a>
              </li>
            </ul>
            <p>如有任何问题，请联系开发者</p>
            <p className="agreement-date">更新日期：2026年7月18日</p>
          </section>
        </main>

        <footer className="privacy-footer">
          <Link to="/" className="back-home-link">回到首页</Link>
          <p className="copyright">© 2026 萝卜水印相机</p>
        </footer>
      </div>
    </div>
  )
}

export default UserAgreementPage
